<ng-container *ngIf="taskLoaded()">
  <div class="wrapper wrapper-content ng-scope animated fadeInRight">
    <div class="container-fluid">
      <!-- 1. ZONA MENSAJE -->
      <div class="row" *ngIf="this.isLoaded() && !this.existsTendersToDecipher()">
        <div class="col-12 alert alert-info" role="alert">
          <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-5" aria-hidden="true"></i>
            {{'TenderEvent.noTenderMessage' | translate}}</span>
        </div>
      </div>
      <!-- FIN ZONA MENSAJE -->
      <!--
    *************************************************************************************************
    1. PASOS DEL EVENTO
    *************************************************************************************************
  -->
      <div style="width:100%;display:inline-block;text-align:center;margin:auto">
        <div *ngFor="let step of steps; let i = index" class="step" [class.step-active]="i == getActiveStep()">
          <div class="step-number">{{ i + 1 }}</div>
          <div class="v-separator v-separatorActive"></div>
          <div class="step-text">{{ step.label }}</div>
          <div class="arrow"></div>
        </div>
      </div>
      <!--
      *************************************************************************************************
      2. ZONA DE IDENTIFICACION
      *************************************************************************************************
    -->
      <ng-container *ngIf="
          getProcurementCommitteeStateValue(
            task.work.procurementCommitteeDTO.state
          ) <=
          getProcurementCommitteeStateValue(CommitteeState.DECIPHER_IN_PROGRESS)
        ">
        <!-- IDENTIFICACION MODO PLYCA-->
        <div class="row" *ngIf="modoIdentificacion === 'PLYCA'">
          <!-- DOCUMENTO DE SOLICITUD DE APERTURA -->
          <div class="col-9">
            <filePDFViewer *ngIf="isLoaded()" #viewer [currentFile]="currentFile" [showZoom]="true" [showPages]="true"
              [showToolbar]="true" [showRotation]="true" [showAllPagesDocument]="false">
            </filePDFViewer>
          </div>
          <!-- MIEMBROS DE LA MESA-->
          <div class="col-3">
            <!-- ZONA WIDGETS-->
            <div class="row">
              <ng-container *ngTemplateOutlet="widgets"></ng-container>
            </div>
            <p-table [value]="memberSignatures" sortField="profile.identifier" sortOrder="1" [paginator]="false"
              class="footer-over-pagination mb-3">
              <ng-template pTemplate="header">
                <tr>
                  <th class="col-icon"></th>
                  <th class="w-75"> {{ 'TenderEvent.memberListHeader' | translate }} </th>
                  <th class="w-auto"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-componente>
                <tr>
                  <td>
                    <span>
                      <i *ngIf="
                          componente.profile &&
                          componente.profile.identifier === 101
                        " class="fas fa-2x fa-user-tie" aria-hidden="true"></i>
                      <i *ngIf="
                          componente.profile &&
                          componente.profile.identifier === 102
                        " class="fas fa-2x fa-user" aria-hidden="true"></i>
                      <i *ngIf="
                          componente.profile &&
                          componente.profile.identifier !== 101 &&
                          componente.profile.identifier !== 102
                        " class="far fa-2x fa-user" aria-hidden="true"></i>
                    </span>
                  </td>
                  <td>
                    <div>
                      <span>
                        <b> {{ componente.profile?.description }}:</b> {{ componente.name }} </span>
                    </div>
                  </td>
                  <td>
                    <button *ngIf="componente.identified" class="btn btn-sm btn-outline-secondary"
                      (click)="validateSignature(componente.signature)" appNoDblClick>
                      <i class="fa fa-check text-success" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr class="text-center">
                  <td colspan="8"> {{ 'General.noFilteredData' | translate }} </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <!-- IDENTIFICACION MODO SECRETO COMPARTIDO (FRAGMENTOS) -->
        <div class="row" *ngIf="modoIdentificacion === 'FRAGMENTOS'">
          <!-- TITULO MIEMBROS MESA -->
          <h4>
            <span class="label label-warning float-right"> {{ 'Procedures.total' | translate }} {{
              task.work.procurementCommitteeDTO.members ? task.work.procurementCommitteeDTO.members.length : '0'
              }}</span>
            <span>
              <i class="fa fa-users" aria-hidden="true"></i> {{ 'TenderEvent.TitleMembers' | translate }}</span>
          </h4>
          <ng-container *ngTemplateOutlet="widgets"></ng-container>
          <p-table #dt [value]="task.work.procurementCommitteeDTO.members" sortField="startInfo.date" sortOrder="1"
            [rows]="50" [paginator]="false" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 50, 100]"
            class="footer-over-pagination">
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="3"> {{ 'General.noFilteredData' | translate }} </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th field="componente.profile" styleClass="col-1"></th>
                <th field="definition.identifier" styleClass="col-9"></th>
                <th styleClass="col-2"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-componente>
              <tr>
                <td field="componente.profile">
                  <span>
                    <i *ngIf="
                      componente.profile &&
                      componente.profile.identifier === 101
                    " class="fa fa-2x fa-user-o" aria-hidden="true"></i>
                    <i *ngIf="
                      componente.profile &&
                      componente.profile.identifier === 102
                    " class="fa fa-2x fa-user" aria-hidden="true"></i>
                    <i *ngIf="
                      componente.profile &&
                      componente.profile.identifier !== 101 &&
                      componente.profile.identifier !== 102
                    " class="far fa-2x fa-user" aria-hidden="true"></i>
                  </span>
                </td>
                <td field="definition.identifier">
                  <div>
                    <span>
                      <b> {{ componente.profile.description }}:</b> {{ componente.user?.person?.fullName }}</span>
                  </div>
                  <!-- Informacion del certificado si esta disponible -->
                  <div *ngIf="
                      componente.certificatePerson &&
                      componente.certificatePerson.identifier !== 0
                    ">
                    <span style="margin-left:5px;">
                      <i class="fa fa-id-card-o" style="margin-right:5px;"></i>{{
                      componente.certificatePerson.certificate.commonName }}</span>
                  </div>
                  <div *ngIf="
                      !componente.certificatePerson ||
                      componente.certificatePerson.identifier === 0
                    ">
                    <br />
                  </div>
                </td>
                <td>
                  <!--
                SI NO SE HA IDENTIFICADO LE PONEMOS EL BOTON, LA MESA ESTA EN EL ESTADO ADECUADO Y EL USUARIO HA APORTADO CERTIFICADO
            -->
                  <button *ngIf="
            task.work.procurementCommitteeDTO.state <
            CommitteeState.DECIPHER_IN_PROGRESS
          " class="btn btn-primary" (click)="identifyMember(componente)" appNoDblClick> {{
                    'TenderEvent.identificationAction' | translate }} </button>
                  <!-- SI SE HA IDENTIFICADO MOSTRAMOS LA INFORMACIÓN -->
                  <span *ngIf="isMemberIdentifierd(componente.user?.identifier)">
                    <small>{{ 'TenderEvent.identificationCorrecta' | translate }}</small>
                    <br />
                    <span>{{ getMemberInfo( componente.identifier, 'dateGenerationSecrets' ) | date: 'medium' }}</span>
                  </span>
                  <!-- INDICAMOS SI NO HA APORTADO CERTIFICADO -->
                  <span *ngIf="
            !componente.certificatePerson ||
            componente.certificatePerson.identifier === 0
          "> {{ 'TenderEvent.noCertificateAvailable' | translate }} </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </ng-container>
      <!--
    *************************************************************************************************
    3. LISTADO DE OFERTAS (solo visible tras la identificacion)
    *************************************************************************************************
  -->
      <div class="row" *ngIf="
          getProcurementCommitteeStateValue(
            task.work.procurementCommitteeDTO.state
          ) > getProcurementCommitteeStateValue(CommitteeState.QUORUM_OK)
        ">
        <!-- TITULO OFERTAS -->
        <h4>
          <a (click)="reloadTenders()" appNoDblClick>
            <span class="label label-warning float-right">{{ 'Procedures.total' | translate }} {{ tenderList ?
              tenderList.length : '0' }}</span>
          </a>
          <i class="fa fa-list" aria-hidden="true"></i> {{ 'TenderEvent.TitleTendersReceived' | translate }}
        </h4>
        <!-- LISTADO OFERTAS -->
        <div class="col-12">
          <p-table [value]="tenderList" sortField="dateTender" [responsive]="true" [rows]="20"
            [paginator]="tenderList && tenderList.length > 20" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]">
            <ng-template pTemplate="header">
              <tr>
                <th [style.width]="'5%'"></th>
                <th [style.width]="'75%'">{{ colHeaders[0] | translate }}</th>
                <th [style.width]="'15%'">{{ colHeaders[1] | translate }}</th>
                <th [style.width]="'5%'"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-expanded="expanded" let-tender>
              <tr>
                <td>
                  <span *ngIf="tender.electronic">
                    <i class="fa fa-desktop" aria-hidden="true"
                      pTooltip="{{'TenderEvent.tenderTable.electronic' | translate}}"></i>
                  </span>
                  <span *ngIf="!tender.electronic">
                    <i class="fa fa-file-text-o" aria-hidden="true"
                      pTooltip="{{'TenderEvent.tenderTable.paper' | translate}}"></i>
                  </span>
                </td>
                <td>
                  <span class="p-column-title">{{ colHeaders[0] | translate }}</span>
                  <span *ngIf="tender.company"> {{ tender.description }} - {{ getCompanyDescription(tender.company)
                    }}</span>
                </td>
                <td>
                  <span class="p-column-title">{{ colHeaders[1] | translate }}</span>
                  <span *ngIf="tender.numRegister">{{ tender.numRegister }}</span>
                </td>
                <td>
                  <div class="btn-group">
                    <!-- <i *ngIf="seeAllActive(tender)" class="mt-1 mr-1 fa fa-2x fa-check text-success"></i> -->
                    <button *ngIf="
                      task.work.procurementCommitteeDTO.state ===
                      CommitteeState.DECIPHERED
                    " class="btn btn-sm btn-primary" aria-expanded="false" (click)="openTender(tender)" appNoDblClick>
                      <i class="fas fa-eye" aria-hidden="true"></i>
                    </button>
                    <i *ngIf="
                      task.work.procurementCommitteeDTO.state !==
                      CommitteeState.DECIPHERED
                    " class="fa fa-lock fa-2x text-danger"></i>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr class="text-center">
                <td colspan="4">{{ 'General.noData' | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<!-- TEMPLATE DE WIDGETS -->
<ng-template #widgets>
  <div class="col-12 col-md-" style="margin-bottom: 5px;">
    <div class="widget style1 bg-azul1">
      <div class="row vertical-align">
        <div class="col-10">
          <span>
            <i class="fa fa-id-card-o fa-lg"></i>
            <span> {{ 'TenderEvent.quorum' | translate }}</span>
          </span>
        </div>
        <div class="col-2 text-right">
          <h2 class="font-bold"> {{ task.work.procurementCommitteeDTO.evaluationCommittee.quorum }} </h2>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-" style="margin-bottom: 5px;">
    <div class="widget style1 label-warning" [class.yellow-bg]="
        membersIdentified <
        task.work.procurementCommitteeDTO.evaluationCommittee.quorum
      " [class.bg-info]="
        membersIdentified >=
        task.work.procurementCommitteeDTO.evaluationCommittee.quorum
      ">
      <div class="row vertical-align">
        <div class="col-10">
          <span>
            <i class="fa fa-check fa-lg"></i>
            <span> {{ 'TenderEvent.identificados' | translate }}</span>
          </span>
        </div>
        <div class="col-2 text-right">
          <h2 class="font-bold">{{ membersIdentified }}</h2>
        </div>
      </div>
    </div>
  </div>
</ng-template>